import React from 'react';
import { FormControl, InputLabel, MenuItem, Select } from '@mui/material';
import { getCountries, getCountryCallingCode } from 'react-phone-number-input/input';

import PropTypes from 'prop-types';
import { getCurLanuagePhone } from '../../business/phoneNumber';

const LCountrySelect = ({label, handleChange,  value, i18n, name, variant = 'outlined' }) => {
  const labels = getCurLanuagePhone(i18n);
  return (
    <FormControl fullWidth required >
      <InputLabel id="demo-simple-select-label">{label}</InputLabel>
      <Select
        variant={variant}
        name= {name}
        labelId="demo-simple-select-label"
        id="demo-simple-select"
        value={value}
        label= {name}
        onChange={handleChange}
      >
        {getCountries().map((country) => (
          <MenuItem key={country} value={getCountryCallingCode(country)}>{labels[country]}</MenuItem>

        ))}
      </Select>
    </FormControl>
  );};

LCountrySelect.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  labels: PropTypes.objectOf(PropTypes.string).isRequired
};

export default LCountrySelect;